import { Grid } from '@mui/material'
import styles from './signup.module.scss'

// import GoogleIcon from '@mui/icons-material/Google'
import SignUpForm from './SignUpForm.jsx'
import AuthCommonCard from '../molecules/AuthCommonCard.jsx'
import AuthCommonForm from '../molecules/AuthCommonForm.jsx'
import { Link } from 'react-router-dom'

const SignUpComp = () => {
	return (
		<AuthCommonCard className={styles.signUpSection}>
			<AuthCommonForm
				title={'Create Your Account'}
				subTitle={
					<>
						Fill in your account details.{' '}
						<Link
							to="/login"
							data-cy="go-to-sign-in"
							className={styles.signInLink}
						>
							Sign in
						</Link>
					</>
				}
			>
				<SignUpForm />
			</AuthCommonForm>
		</AuthCommonCard>
	)
}

export default SignUpComp
